module.exports = __webpack_public_path__ + "static/media/pages.0033e8b3.png";